import { Box } from "@material-ui/core";
import * as React from "react";

const Separator = () => <Box pt="1em" />;

export default Separator;
